import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import 'commons-forms/components/MessageHandler/MessageHandler.scss';

class MessageHandler extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showElement: props.body,
        };

        this.closeElement = this.closeElement.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.body) {
            this.setState({
                showElement: true,
            });
        }
    }

    closeElement() {
        this.setState({
            showElement: false,
        });
    }

    render() {
        const classes = this.props.classes.concat(['message-handler', this.props.code]);
        const closeIcon = this.props.canCloseElement && (
            <button className="closeIconWrapper" onClick={this.closeElement}>
                <icon className="icon-x-config" />
            </button>
        );

        const messageIcon = this.props.messageIcon && (
            <div className="iconWrapper">
                <icon className={this.props.messageIcon} />
            </div>
        );

        if (!this.state.messageIcon) {
            classes.push('hasIcon');
        }

        return (
            <ReactCollapse isOpened={this.state.showElement} springConfig={{ stiffness: 200, damping: 30 }}>
                <div className={classes.join(' ')}>
                    {closeIcon}
                    {messageIcon}
                    {this.props.body}
                </div>
            </ReactCollapse>
        );
    }
}

MessageHandler.defaultProps = {
    canCloseElement: true,
    classes: [],
    code: 'success',
    messageIcon: '',
};

MessageHandler.propTypes = {
    body: PropTypes.node.isRequired,
    canCloseElement: PropTypes.bool,
    classes: PropTypes.arrayOf(PropTypes.string),
    code: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    messageIcon: PropTypes.string,
};

MessageHandler.displayName = 'MessageHandler';

export default MessageHandler;
